var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffinityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.64,32.76h-3.53c-1.94,0-3.53,1.59-3.53,3.53s1.59,3.53,3.53,3.53h3.53c1.94,0,3.53-1.59,3.53-3.53s-1.59-3.53-3.53-3.53Zm14.12-3.53h-3.53c-1.94,0-3.53,1.59-3.53,3.53v3.53c0,1.94,1.59,3.53,3.53,3.53h3.53c1.94,0,3.53-1.59,3.53-3.53v-3.53c0-1.94-1.59-3.53-3.53-3.53Zm14.12-7.06h-3.53c-1.94,0-3.53,1.59-3.53,3.53v10.59c0,1.94,1.59,3.53,3.53,3.53h3.53c1.94,0,3.53-1.59,3.53-3.53v-10.59c0-1.94-1.59-3.53-3.53-3.53Zm1.77-17.65h-11.65c-1.59,0-2.29,1.94-1.24,3l3.35,3.35c-6.53,7.41-15.89,13.06-25.77,13.06-1.06,0-1.77.71-1.77,1.77s.71,1.77,1.77,1.77c11.83,0,22.77-3.35,30.71-11.65l3.18,3.18c1.06,1.06,3,.35,3-1.24V6.29c.18-1.06-.53-1.77-1.59-1.77h0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffinityIcon);
export default __webpack_public_path__ + "static/media/affinity-icon.fa1d5aa8ea23a993249e5f5ef22cb7da.svg";
export { ForwardRef as ReactComponent };